module.exports = "video {\n  width: 100%;\n  height: 100%;\n  background: #000; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/media-player/media-player.component.scss
// module id = ./src/app/shared/components/media-player/media-player.component.scss
// module chunks = main